import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {UserService} from './user.service';

@Injectable()
export class TestGuard implements CanActivate {
  constructor(private userService: UserService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.userService.getLocal().testing) {
      this.router.navigate(['/dashboard/testing']);
    }
    return this.userService.getLocal() != null ? !this.userService.getLocal().testing : true;
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/test-guard.service.ts